import {useEffect, useState} from "react";
import {getAllDepots, getAllPPays} from "../../services/httpServices";
import {DepotsContext} from "./DepotsContext";
import Spinner from "../../components/Spinner/Spinner";

export default function DepotsProvider({children}) {
    const [depots, setDepots] = useState([]);
    const [ppays, setPpays] = useState([]);

    const refreshDepots = () => {
        getAllDepots().then(res => {
                setDepots(res.data || [])
            }
        )
    }

    useEffect(() => {
        refreshDepots();

        getAllPPays().then(res => setPpays(res.data));
    }, [])

    return (
        <DepotsContext.Provider value={{depots, refreshDepots, ppays}}>
            {depots ? children : <Spinner/>}
        </DepotsContext.Provider>
    )
}
